module.exports = __webpack_public_path__ + "static/media/visionLogo.13984ae1.png";